export default __webpack_public_path__ + "static/media/basket-buy-banner.670332c8.gif";